<template>
  <validation-observer v-slot="{ invalid }">
    <v-container class="px-4 py-4" fluid>
      <v-row dense class="mb-1">
        <v-col cols="4">
          <FileInput v-model="file" :label="$t('ELE0081')" accept=".txt, .csv" rules="ext:txt,csv" required />
        </v-col>
        <v-col>
          <BtnImport @click="onClickImport" :disabled="invalid" />
        </v-col>
        <v-col>
          <BtnCsvDownload :label="$t('ELE0076')" fileTitle="import_lot" :items="emptyCsvContents" />
        </v-col>
        <v-col>
          <Btn :label="$t('ELE0079')" @click="onClickSearchInspLot" />
        </v-col>
      </v-row>
      <v-row v-if="clickImportFlag">
        <v-col>
          <v-card outlined>
            <v-card-title>
              {{ $t('ELE0077') }}
            </v-card-title>
            <v-card v-if="successedImportFlag" outlined class="mx-auto" color="green lighten-5" width="600px">
              <v-card-title>
                <v-row>
                  <v-col class="d-flex flex-row space-between">
                    <span class="mx-3">
                      <v-avatar color="green" size="36">
                        <v-icon color="white">mdi-check-bold</v-icon>
                      </v-avatar>
                    </span>
                    <span class="pt-1">
                      {{ $t('MSG0038', { p0: successLineCount }) }}
                    </span>
                  </v-col>
                </v-row>
              </v-card-title>
            </v-card>
            <v-card v-if="errorList.length > 0" outlined class="mx-auto" color="red lighten-5" width="600px">
              <v-card-title class="text-h5 justify-center">
                {{ $t('MSG0039') }}
              </v-card-title>
              <v-card-text class="text-h6 font-weight-normal black--text">
                <v-row>
                  <v-col class="d-flex flex-row">
                    <span class="mx-3">
                      <v-avatar color="red" size="36" class="px-2">
                        <v-icon color="white">mdi-exclamation-thick</v-icon>
                      </v-avatar>
                    </span>
                    <span class="pt-1">{{ $t('MSG0040', { p0: errorLineCount }) }}</span>
                    <v-spacer />
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
            <v-card-text>
              <v-data-table v-if="errorList.length > 0" dense :headers="headers" :items="errorList">
                <template v-slot:item.text="{ item }">
                  <div class="py-1" style="white-space: pre">{{ item.text }}</div>
                </template>
              </v-data-table>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </validation-observer>
</template>

<script>
import { mapGetters } from 'vuex'
import { ValidationObserver } from 'vee-validate'
import { API } from '@/plugins/api'
import APIUtils from '@/mixin/api-utils.js'
import Message from '@/mixin/message-utils.js'
import Loading from '@/mixin/loading-utils.js'
import DateUtil from '@/mixin/date-utils.js'

import Btn from '@/components/atoms/base/button/Btn'
import BtnImport from '@/components/atoms/button/BtnImport'
import FileInput from '@/components/atoms/base/file/FileInput'
import BtnCsvDownload from '@/components/atoms/button/BtnCsvDownload'

export default {
  name: 'ImpInspLotCSVForm',

  mixins: [APIUtils, Message, Loading, DateUtil],

  components: {
    ValidationObserver,
    Btn,
    BtnImport,
    FileInput,
    BtnCsvDownload,
  },

  data() {
    return {
      file: null,
      errorList: [],
      successLineCount: '',
      errorLineCount: '',
      clickImportFlag: false,
      successedImportFlag: false,
      headers: [
        { text: this.$t('ELE0084'), value: 'line', divider: true, width: '125', align: 'end' },
        { text: this.$t('ELE0085'), value: 'text', divider: true },
      ],
      emptyCsvContents: [
        {
          [this.$t('ELE0049')]: '',
          [this.$t('ELE0031')]: '',
          [this.$t('ELE0050')]: '',
          [this.$t('ELE0394')]: '',
          [this.$t('ELE0395')]: '',
          [this.$t('ELE0055')]: '',
          [this.$t('ELE0054')]: '',
          [this.$t('ELE0056')]: '',
          [this.$t('ELE0368')]: '',
        },
      ],
    }
  },

  computed: {
    ...mapGetters(['userCd']),
  },

  methods: {
    onClickSearchInspLot() {
      this.$router.push({ name: 'T15' }).catch()
    },
    onClickImport() {
      this.errorList = []
      this.clickImportFlag = true
      this.successedImportFlag = false
      try {
        this.csvToJson(this.checkBox)
      } catch (error) {
        this.setErrorMessage(this.resolveErrorMessage(error, this.$t('MSG0003', { p0: this.$t('ELE0078') })))
      } finally {
        this.file = null
      }
    },
    csvToJson(callback) {
      this.$papa.parse(this.file, {
        skipEmptyLines: true,
        complete: function (results) {
          callback(results.data)
        },
      })
    },
    async checkBox(csvData) {
      if (csvData)
        try {
          this.startLoading()
          if (csvData[0].length != 9) {
            this.setErrorMessage(this.$t('MSG0028'))
            return
          }

          const items = this.getItems(csvData)
          let body = {
            items: items,
            userCd: this.userCd,
          }
          const elements = await API.post('/box/checkInspBoxes', body)
          if (elements.isResult) {
            this.successLineCount = elements.successLineCount
            await this.registerBox(items)
          } else {
            this.errorLineCount = elements.errorLineCount
            elements.errorMessages.forEach((element) => {
              const item = {
                line: element.lineNo + 2, // Excelの行数と合わせるため+2
                text: element.bodies.join('\r\n'),
              }
              this.errorList.push(item)
            })
          }
        } catch (error) {
          this.setErrorMessage(this.resolveErrorMessage(error, this.$t('MSG0003', { p0: this.$t('ELE0078') })))
        } finally {
          this.stopLoading()
        }
    },
    async registerBox(items) {
      try {
        let body = {
          items: items,
          userCd: this.userCd,
        }
        await API.post('/box/registerInspBoxes', body)
        this.setSuccessMessage(this.$t('MSG0041'))
        this.successedImportFlag = true
      } catch (error) {
        this.setErrorMessage(this.resolveErrorMessage(error, this.$t('MSG0003', { p0: this.$t('ELE0078') })))
      }
    },
    getItems(csvData) {
      let items = []
      for (let index = 1; index <= csvData.length - 1; index++) {
        let item = {}
        item.lotNo = csvData[index][0]
        item.partCd = csvData[index][1]
        item.qty = csvData[index][2]
        item.manufacturerCd = csvData[index][3]
        item.acceptCompanyCd = csvData[index][4]
        item.acceptDatetime = this.toServerTime(csvData[index][5])
        item.remarks = csvData[index][6]
        item.refNo = csvData[index][7]
        item.everyKey = csvData[index][8]
        items.push(item)
      }
      return items
    },
    reset() {
      this.file = null
      this.errorList = []
      this.clickImportFlag = false
      this.successedImportFlag = false
    },
  },
}
</script>
